export const isNullOrWhitespace = (text) => !text || !text.trim();

export const booleanToTextOrUndefined = (value) =>
  ({ [true]: "Yes", [false]: "No" }[value]);

export const getLowerCaseStringValue = (text) =>
  text?.toString()?.toLowerCase();
